// @flow
import { Backbone } from "extensions/backbone";
import humanize from "lodash-es/startCase";

import strings from "common/strings";
import {
    validateEmail,
    hashStringToColor
} from "common/utils";
import { store } from "common/store";

export const UserModel = Backbone.Model.extend({
    idAttribute: "_id",
    
    defaults: () => ({
        avatar: null,
        username: "",
        first_name: "",
        last_name: "",
        job_title: "",
        active: true,
        sso_user: false,
        merchant_ref: "",
        admin: false,
        superuser: false,
        switch_packages: false,
        processors: [],
        business_units: [],
        groups: [],
        merchants: null
    }),
    
    isLocked(): boolean {
        return this.get("locked");
    },
    
    isDeactivated(): boolean {
        return this.get("active") === false;
    },
    
    isActive(): boolean {
        return this.get("active") === true;
    },
    
    isSsoUser(): boolean {
        return this.get("sso_user") === true;
    },
    
    getUserColor() {
        return hashStringToColor(this.get("username"));
    },
    
    getDisplayName() {
        const username = this.get("username");
        const firstName = this.get("first_name");
        
        let displayName;
        
        // If user has a first name then use it
        if (firstName) {
            displayName = firstName;
        } else if (validateEmail(username)) {
            try {
                [displayName] = username.split("@");
            } catch {
                // Noop
            }
        } else {
            displayName = strings.pazienUser;
        }
        
        return humanize(displayName);
    },
    
    validate(attrs) {
        const errors = [];
        if (!attrs.first_name) {
            errors.push({
                name: "first_name",
                message: strings.preferences.profile.errors.emptyFirstName
            });
        }

        if (!attrs.last_name) {
            errors.push({
                name: "last_name",
                message: strings.preferences.profile.errors.emptyLastName
            });
        }
        
        if (!attrs.username) {
            errors.push({
                name: "username",
                message: strings.preferences.profile.errors.emptyEmail
            });
        }
        
        if (!attrs.merchant_ref) {
            errors.push({
                name: "merchant_ref",
                message: strings.preferences.profile.errors.emptyMerchantRef
            });
        }
        
        return errors.length > 0 ? errors : false;
    },
    
    /**
     * A little issue is that we can transfer a user from one BU to another then Backbone cannot manage model url
     */
    setUrl(selectedBU) {
        if (this.isNew() && selectedBU) {
            this.url = `/merchant/${selectedBU}/users/`;
        } else {
            this.url = `/merchant/${this.get("merchant_ref")}/users/${this.id}`;
        }
    },
    
    hasNeverLoggedIn(): boolean {
        return !this.get("last_login");
    },
    
    isMerchantAdmin(): boolean {
        return this.get("admin") || this.get("superuser");
    },
    
    isWorldpayRm(): boolean {
        return this.get("merchant_ref") === store.getState().config.worldpayMerchant;
    },
    
    isSuperUser(): boolean {
        return this.get("superuser");
    },
    
    canSwitchPackages(): boolean {
        return this.get("switch_packages");
    },
    
    lock() {
        return this.save({ locked: true });
    },
    
    toJstJSON(...args) {
        return Object.assign(Backbone.Model.prototype.toJSON.call(this, ...args), {
            worldpay_rm: this.isWorldpayRm()
        });
    }
});
